import { render } from "./PageB2FREChopDetectorAtxStrategy.vue?vue&type=template&id=0b9dc4c6"
import script from "./PageB2FREChopDetectorAtxStrategy.vue?vue&type=script&lang=js"
export * from "./PageB2FREChopDetectorAtxStrategy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__